import React from "react";
import { View, Image, StyleSheet, Text } from "react-native";
import argireline from '../../assets/ingredients/Argireline.png';
import ascorbic from '../../assets/ingredients/ascorbic.png';
import hyaluronic from '../../assets/ingredients/hyaluronic.png';
import niacinamide from '../../assets/ingredients/niacinamide.png';
import retinol from '../../assets/ingredients/retinol.png';
import oatExtract from '../../assets/ingredients/oatExtract.png'

export const IngredientImage = ({ ingredient }) => {
  const ingredients = [
    { ingredientName: 'Argireline', description: "Reduces the appearance of fine lines/wrinkles; skin-plumping effect; extends the effect of injectable treatments; smoothing.", photoName: "argireline", url: argireline },
    { ingredientName: 'Ascorbic Acid', description: "Antioxidant; brightens skin tone and pigmentation; clears blemishes, encourages collagen production; heals sun damage; helps reduce appearance of fine lines and wrinkles; moisturizing.", photoName: "ascorbic", url: ascorbic },
    { ingredientName: 'Hyaluronic Acid', description: "Moisture retention; improves collagen production, prevents tightness; improves elasticity and scar healing; evens skin tone. ", photoName: "hyaluronic", url: hyaluronic },
    { ingredientName: 'Niacinamide', description: "Minimizes enlarged pores; improve uneven skin tone;  softens fine lines and wrinkles, diminishes dullness; strengthens skin barrier; helps to repair past damage.", photoName: "niacinamide", url: niacinamide },
    { ingredientName: 'Retinol', description: "Anti-aging; blemish clearing; exfoliation; helps reduce appearance of fine lines and wrinkles.", photoName: "retinol", url: retinol },
    { ingredientName: 'Oat Extract', description: "Strengthens skin barrier; soothing; moisturizing.", photoName: "oatExtract", url: oatExtract }
  ];
  const currIngredient = ingredients.find((p) => p.photoName === ingredient);

  return (
    <View style={styles.container}>
      <View style={styles.imageContainer}>
          <Image style={styles.image} source={{ uri: currIngredient.url }} resizeMode="cover" />
      </View>
      <Text style={styles.label}>{currIngredient.ingredientName}</Text>
      <Text style={styles.description}>{currIngredient.description}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: 'center',
    height: 'fit-content',
    margin: 2,
  },
  imageContainer: {
    width: 75,
    height: 75,
    borderRadius: 75,
    backgroundColor: '#D6C2AA',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden', // Ensures image stays within the circular container
  },
  image: {
    //flex: 1,
    //maxHeight:60,
    //maxWidth: 60,
    height: 65,
    width: 65,
    borderRadius: '100%',
    border: '8px'
  },
  label: {
    textAlign: "center",
    fontFamily: 'DM Sans',
    fontSize: 20,
  },
  description: {
    textAlign: "center",
    fontFamily: 'DM Sans',
    fontSize: 14,
    maxWidth: 140
  },
});

